import heroImg from "../components/images/ranchWeddingImages/image36.jpg";
import MyGallery from "../components/GalleryImages";
import '../assets/css/gallery.css';

export default function Gallery() {
  return (
    <>
      <div className="gallery-hero">
        <img className="gallery-hero-img" src={heroImg} alt="Cascade Mountain Ranch wedding gallery" />
        <div className="gallery-hero-overlay">
          <p className="gallery-hero-eyebrow">Cascade Mountain Ranch</p>
          <h1>Gallery</h1>
          <p className="gallery-hero-sub">Moments from Our Events</p>
        </div>
      </div>

      <div className="gallery-intro">
        <div className="gallery-accent-line"></div>
        <p>Take a look at some of the moments captured at Cascade Mountain Ranch.</p>
      </div>

      <MyGallery />
    </>
  );
}
